document.addEventListener('DOMContentLoaded', function () {

  const krwBox     = document.getElementById('krw-price-box');
  const krwPriceEl = document.getElementById('krwPrice');
  const krwRateEl  = document.getElementById('krwRate');

  if (!krwBox || !krwPriceEl || !krwRateEl) return;

  const url = 'https://open.er-api.com/v6/latest/EUR';

  let currentRate = null;

  function hideKrwBox() {
    krwBox.style.display = 'none';
  }

  function updateKRW(eur) {
    if (!currentRate) return;

    const krw = Math.round(eur * currentRate);

    krwPriceEl.textContent =
      `₩${krw.toLocaleString('ko-KR')} KRW (예상가)`;
  }

  fetch(url)
    .then(res => res.json())
    .then(data => {

      if (data.result !== "success" || !data.rates?.KRW) {
        hideKrwBox();
        return;
      }

      currentRate = data.rates.KRW;

      krwRateEl.textContent =
        `🔎 1 EUR = ${currentRate.toLocaleString('ko-KR')} KRW`;

      // Initial price
      if (typeof window.productPriceEur === 'number') {
        updateKRW(window.productPriceEur);
      }
    })
    .catch(err => {
      console.error("FX API error:", err);
      hideKrwBox();
    });

  document.addEventListener('variant:change', function (event) {

    if (!event.detail?.variant?.price) return;

    const eur = event.detail.variant.price / 100;
    updateKRW(eur);
  });

});